// extracted by mini-css-extract-plugin
module.exports = {"container":"yx-z","productName":"zx-z","modal":"Ax-z","dimensions":"Bx-z","recipientEmail":"Cx-z","lowStock":"Dx-z","recommendedFit":"Ex-z","notRecommendedFit":"Fx-z"};